import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Component, DestroyRef, Input, OnInit } from '@angular/core';
import { OrderDetailAgreement, OrderDetailField } from '@vendasta/sales-ui';
import { Status, UserInterface, Order } from '@vendasta/sales-orders';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'agreements',
  templateUrl: 'agreements.component.html',
  styleUrls: ['agreements.component.scss', '../history/history.component.scss'],
  standalone: false,
})
export class AgreementsComponent implements OnInit {
  @Input() order: Order;
  @Input() salesOrderUsers$: Observable<{ [key: string]: UserInterface }>;
  @Input() openExpansionPanel$: Observable<boolean>;

  orderDetails: OrderDetailField[];
  approvalDate: string;
  agreements: OrderDetailAgreement[];

  constructor(private readonly destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.initAgreements();
    this.initApprovalDate();
  }

  private initAgreements(): void {
    this.salesOrderUsers$
      .pipe(
        map((users) => {
          return OrderDetailAgreement.createFromOrderWithUsers(this.order, users);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((agreements) => {
        this.agreements = agreements;
      });
  }

  private initApprovalDate(): void {
    this.salesOrderUsers$
      .pipe(
        map((users) => {
          return OrderDetailField.createFromOrderWithUsers(this.order, users);
        }),
        take(1),
      )
      .subscribe((orderDetails) => {
        this.orderDetails = orderDetails;
        const customerApproval = this.getLastCustomerApproval();
        if (customerApproval) {
          this.approvalDate = new DatePipe('en-US').transform(customerApproval.date, 'MMMM d, y, h:mm:ss a');
        }
      });
  }

  getLastCustomerApproval(): OrderDetailField {
    if (!this.orderDetails) {
      return null;
    }
    // Clone the order details so reverse doesn't break the original array
    const orderDetailsCopy = [...this.orderDetails];
    orderDetailsCopy.reverse();
    // Get the matching history item if at least two entries exist and one is approved by the customer
    return orderDetailsCopy.find(
      (historyItem, index, statusHistory) =>
        index < statusHistory.length - 1 &&
        !historyItem.status &&
        statusHistory[index + 1].status &&
        statusHistory[index + 1].status === Status.SUBMITTED_FOR_CUSTOMER_APPROVAL,
    );
  }
}
